import { DOMAIN_TYPE } from 'store/page/constants';

const DOMAIN_NAME = 'forecast';

export const SET_SELECTED_WEEK =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_SELECTED_WEEK` as const;

export const START_CREATE_FORECAST =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_CREATE_FORECAST` as const;

export const START_FORECAST_WEEK =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_FORECAST_WEEK` as const;
